import { type ResponseItemType } from '@/common/types/response.type';
import { type ITenantConfig } from '@/common/types/tenant-config.types';
import Client from '@/common/utils/client.utility';

export type GetConfigType = () => Promise<ResponseItemType<ITenantConfig>>;

export const getTenantConfigService: GetConfigType = async () => {
  const client = new Client();
  return await client.get(`/v1/personalpage/Shopper/Config`);
};
